module.exports = __webpack_public_path__ + "static/media/phone-square.447f8231.svg";